import type { PeopleDto } from 'shared/dtos/people.dto';

import { PeopleList } from 'components/lists/people-list/people-list';
import { GrayPanel } from 'components/panels/gray-panel/gray-panel';
import { FormBody } from 'components/template/form-body/form-body';
import { FormHeader } from 'components/template/form-header/FormHeader';
import { useEffect } from 'react';
import { ASSIGN_PEOPLE_MODAL, MODAL_PEOPLE } from 'shared/constants/modals';
import { useAppDispatch, useAppSelector } from 'store';
import { closeModal, openModal } from 'store/modals/modals.slice';
import {
  setSelectedPeopleForAgency,
  setSelectedPeopleForDivision,
} from 'store/people/people.slice';
import { getPeopleThunk } from 'store/people/people.thunks';
import { vocabulary } from 'vocabulary/german';

export const AssignPeopleForm = ({
  forEntity,
}: {
  forEntity?: 'agency' | 'division';
}) => {
  const dispatch = useAppDispatch();
  const people = useAppSelector((state) => state.people);

  const handleCreatePeople = () => {
    dispatch(openModal({ name: MODAL_PEOPLE }));
  };

  const selectPeople = (people: PeopleDto) => {
    if (forEntity) {
      if (forEntity === 'agency') {
        dispatch(setSelectedPeopleForAgency({ peopleId: people.id }));
      }

      if (forEntity === 'division') {
        dispatch(setSelectedPeopleForDivision({ peopleId: people.id }));
      }

      dispatch(closeModal({ name: ASSIGN_PEOPLE_MODAL }));
    }
  };

  useEffect(() => {
    dispatch(getPeopleThunk());
  }, [dispatch]);

  return (
    <>
      <FormHeader />
      <FormBody noMargin>
        <GrayPanel text={vocabulary.labels.assignPersonToAgency} />
        <div className="container">
          <PeopleList
            isSelectable={true}
            people={people}
            createClick={handleCreatePeople}
            panelClick={(people: PeopleDto) => selectPeople(people)}
          />
        </div>
      </FormBody>
    </>
  );
};
